import { ChevronDown, ExternalLink } from "lucide-react";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";

const HERO_BG = "https://images.unsplash.com/photo-1768661607952-117b2d081b15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxtb29keSUyMGRhcmslMjBjcmltZSUyMHRocmlsbGVyJTIwYXRtb3NwaGVyZSUyMGZvZyUyMG15c3Rlcnl8ZW58MHx8fHwxNzczMDc3NDkzfDA&ixlib=rb-4.1.0&q=85";

export default function HeroSection({ latestBook }) {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-black/85" />

      <div className="container mx-auto px-4 md:px-8 max-w-7xl relative z-10 pt-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <p className="text-rose-700 uppercase tracking-[0.3em] text-sm font-bold animate-fade-in-up">
              Crime Thriller Author
            </p>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-black text-white mt-4 leading-none animate-fade-in-up animation-delay-100">
              Derek Fee
            </h1>
            <p className="text-zinc-400 text-base md:text-lg leading-relaxed mt-8 max-w-lg animate-fade-in-up animation-delay-200">
              Creator of the popular detective series The Belfast Murders and Galway Murders.
              Weaving intricate plots of corruption, criminality, and human nature against
              the backdrop of Ireland's gritty cities and serene coasts.
            </p>
            <div className="flex flex-wrap gap-4 mt-10 animate-fade-in-up animation-delay-300">
              <a
                href="https://www.amazon.com/stores/Derek-Fee/author/B001K87YMI"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  data-testid="hero-amazon-btn"
                  className="bg-rose-700 hover:bg-rose-800 text-white rounded-none px-8 py-6 text-sm uppercase tracking-widest"
                >
                  Visit Amazon Page
                  <ExternalLink className="ml-2 h-4 w-4" />
                </Button>
              </a>
              <a href="#books">
                <Button
                  data-testid="hero-explore-btn"
                  variant="outline"
                  className="border-white/20 text-white hover:bg-white/10 rounded-none px-8 py-6 text-sm uppercase tracking-widest"
                >
                  Explore Books
                </Button>
              </a>
            </div>
          </div>

          {latestBook && (
            <div className="flex justify-center md:justify-end animate-fade-in-up animation-delay-400">
              <div className="relative group">
                <Badge className="absolute -top-3 left-4 z-20 bg-rose-700 text-white border-0 rounded-none px-4 py-1.5 uppercase tracking-widest text-xs">
                  Latest Release
                </Badge>
                <div className="noir-glow">
                  <img
                    src={latestBook.cover_url}
                    alt={`${latestBook.title} - Latest Irish crime thriller by Derek Fee`}
                    className="w-64 md:w-80 object-cover shadow-2xl"
                  />
                </div>
                <div className="mt-4">
                  <h3 className="font-display text-xl text-white font-bold">{latestBook.title}</h3>
                  <p className="text-zinc-500 text-sm mt-1">{latestBook.series}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <a
        href="#books"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-zinc-500 hover:text-white transition-colors animate-bounce"
      >
        <ChevronDown className="h-6 w-6" />
      </a>
    </section>
  );
}
